"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateSameOrigin = exports.validateEventOrigin = void 0;
function validateEventOrigin(event, origin) {
    if (event.origin !== origin) {
        console.warn(`WARNING: expected origin '${origin}', got '${event.origin}' (ignoring)`);
        return false;
    }
    return true;
}
exports.validateEventOrigin = validateEventOrigin;
function validateSameOrigin(event, origin) {
    console.debug('validateSameOrigin', {
        origin,
        event,
    });
    if (event.source !== origin) {
        console.warn(`WARNING: expected same origin (ignoring)`, { event, origin });
        return false;
    }
    return true;
}
exports.validateSameOrigin = validateSameOrigin;
